export enum BuildingAdminNavItem {
  BuildingData = "NAVIGATION.BUILDING_DATA",
  Campus = "NAVIGATION.CAMPUS",
  Building = "NAVIGATION.BUILDING",
  Zone = "NAVIGATION.ZONE",
  LocationType = "NAVIGATION.LOCATION_TYPE",
  LocationTypeServices = "NAVIGATION.LOCATION_TYPE_SERVICES",
  Location = "NAVIGATION.LOCATION",
  Service = "NAVIGATION.SERVICE",
  Asset = "NAVIGATION.ASSET"
}
